import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import BusinessInfo from './components/BusinessInfo';
import AnalysisView from './components/AnalysisView';
import './App.css';
import { CheckoutForm, ReturnForm } from './components/Checkout';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/business-info" element={<BusinessInfo />} />
        <Route path="/checkout" element={<CheckoutForm/>} />
        <Route path="/return" element={<ReturnForm/>} />
        <Route path="/analysis/:reportId" element={<AnalysisView/>} />
      </Routes>
    </Router>
  );
}

export default App;
